const MenuOverlayToggler = () => {

	document.querySelector('#menu-overlay-toggler').addEventListener('click', (e) => {
		e.preventDefault();
		document.body.classList.toggle('js-menu-overlay-revealed');
	});

};

export default MenuOverlayToggler;